<!-- 物理因素职业接触限值超高频辐射 -->
<template>
  <div class="tableBoxShadow">
    <h5 :class="['title',{mobileFontSize:$isMobile}]">{{tableData[0]&&tableData[0].desc}}</h5>
    <el-table :class="{mobileTable:$isMobile}" :data="tableData" style="width: 100%">
      <el-table-column align="center" prop="touchDuration" label="接触时间">
      </el-table-column>
      <el-table-column align="center" label="连续波">
        <el-table-column align="center" label="功率密度(mW/cm2)">
          <template slot='header'>
            <span>功率密度(mW/cm</span>
            <sup>2</sup>
            <span>)</span>
          </template>
          <template slot-scope="scope">
            <p>{{scope.row.seriesWave.powerDensity}}</p>
          </template>
        </el-table-column>
        <el-table-column align="center" label="电场强度(V/m)">
          <template slot-scope="scope">
            <p>{{scope.row.seriesWave.electricIntensity}}</p>
          </template>
        </el-table-column>
      </el-table-column>
      <el-table-column align="center" label="脉冲波">
        <el-table-column align="center" label="功率密度(mW/cm2)">
          <template slot='header'>
            <span>功率密度(mW/cm</span>
            <sup>2</sup>
            <span>)</span>
          </template>
          <template slot-scope="scope">
            <p>{{scope.row.pulseWave.powerDensity}}</p>
          </template>
        </el-table-column>
        <el-table-column align="center" label="电场强度(V/m)">
          <template slot-scope="scope">
            <p>{{scope.row.pulseWave.electricIntensity}}</p>
          </template>
        </el-table-column>
      </el-table-column>
    </el-table>
  </div>
</template>

<script>
  export default {
    data() {
      return {
        tableData: [],
      }
    },
    created() {
      this.findUltraHighRadiationTouch()
    },
    methods: {
      async findUltraHighRadiationTouch(){
        let res = await this.$axios.get(this.$serviceAPI.findUltraHighRadiationTouch)
        this.tableData = res.data.data
      }
    }
  }
</script>

<style scoped="scoped">

</style>



// WEBPACK FOOTER //
// src/components/subPage/ultraHighRadiationTouch.vue